import { render, staticRenderFns } from "./Stock_Aceite.vue?vue&type=template&id=264c4c09&"
import script from "./Stock_Aceite.vue?vue&type=script&lang=js&"
export * from "./Stock_Aceite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports